<!-- Open guide button -->
<span class="btn btn-sm btn-outline-info" (click)="openUserGuide(guide == 'qiGuide' ? qiGuide : null)">
  <i class="far fa-question-circle me-1"></i>User Guide
</span>

<!-- Quility Improvement Guide -->
<ng-template #qiGuide let-modal>
  <div class="modal-body user-guide">
    <h3>User Guide</h3>
    <h5 class="text-dark">Quality Improvement Tool</h5>
    <hr>
    <h6>Step 1</h6>
    <p>
      Select an area from the blue selector at the top of the page. You can choose between multiple system levels, including STP, CCG, PCN and practice level. All system levels are searchable using the search box above the list.
    </p>
    <p>
      To select a specific practice, first select the PCN that the practice falls within. Then go back to the selected, click 'Practice', and a list of all practices within the PCN will be shown.
    </p>
    <p>
      Some practices are not assigned to a PCN. To search these, click on 'Practice' and click on the box that says 'Practices unassigned to a PCN'. A list of these practices will then show.
    </p>
    <h6>Step 2</h6>
    <p>
      Once you have selected an area, the Quality Improvement Tool will display all available indicators at the area's system level. The indicators are further split by inequalities markers.
    </p>
    <p>
      By default, only one marker will show per indicator: the "all persons" marker (Sex: Persons, Persons).
    </p>
    <p>
      This view can be filtered in three ways using the filter selected above the indicators:
    </p>
    <ul>
      <li>
        <strong>Filter by inequalities markers:</strong> This allows you to select which markers show. Choose to show all markers, a specific sex, or a specific category (e.g. age groups).
      </li>
      <li>
        <strong>Filter by quintile:</strong> Each marker shows the system level data split into quintiles, with the selected area's value highlighted.
      </li>
    </ul>
  </div>
</ng-template>
